import LuxtrustCard from './LuxtrustCard';

export default LuxtrustCard;
